import { render, staticRenderFns } from "./AnnualReduction.vue?vue&type=template&id=40d862fa&scoped=true"
import script from "./AnnualReduction.vue?vue&type=script&lang=js"
export * from "./AnnualReduction.vue?vue&type=script&lang=js"
import style0 from "./AnnualReduction.vue?vue&type=style&index=0&id=40d862fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d862fa",
  null
  
)

export default component.exports